import { Box, Tooltip, Typography } from "@mui/material";
import { MRT_ColumnDef } from "material-react-table";
import { capitalizeFirstLetter, formatCurrency, validateDate } from "../../utils/utils";
import { Link } from "react-router-dom";
import Ask7GIcon from "../../assets/common/ask7g-icon.svg";
import SelectedAsk7GIcon from "../../assets/common/ask7g-selected.svg";
import { useState } from "react";
import useGlobalContext from "../../context/useGlobalContext";
import ColumnFilter from "../Common/customFilter";
import EllipsedTooltip from "../Common/EllipsedTooltip";

const displayValue = (val: any) => {
  if (val === null || val === undefined || val === "") return "---";
  return val;
};
const initialSorting = { sort_field: "account", sort_order: "asc" as "asc" | "desc" };
const getDefaultAccountColumns = (
  columnFilters?: any,
  setColumnFilters?: React.Dispatch<React.SetStateAction<any>>,
  sort?: { sort_field: string; sort_order?: "asc" | "desc" },
  onSortChange?: (field: string, order: "asc" | "desc") => void,
  openFilterColumn?: string | null,
  setOpenFilterColumn?: React.Dispatch<React.SetStateAction<string | null>>
): MRT_ColumnDef<any>[] => {
  const isAccountFilterActive =
    openFilterColumn === "account" ||
    (Array.isArray(columnFilters?.account) &&
      columnFilters.account.length > 0);

  return [
    {
      accessorKey: "account",
      header: "",
      Header: (
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            padding: "0px",
          }}>
          <Typography
            className="cf-title"
            sx={{ color: Array.isArray(columnFilters?.account) &&
                        columnFilters.account.length > 0 ? "#6036d6" : "inherit",
                }}
          >
            Account Name </Typography>
          <ColumnFilter
            currentValue={columnFilters?.account ?? []}
            onApply={(val) =>
              setColumnFilters?.((prev: any) => ({
                ...prev,
                account:
                  typeof val === "string" && val.trim()
                    ? [val.trim()]
                    : undefined,
              }))
            }
            options={[]}
            type="multi"
            showSections={{
              apply: false,
              options: false,
              sort: false,
            }}
            columnKey="account"
            placeHolder={"Search by Account"}
            onOpen={() => setOpenFilterColumn?.("account")}
            onClose={() => setOpenFilterColumn?.(null)}
            isActive={isAccountFilterActive}
            sortDirection={
              sort?.sort_field === "account" ? sort.sort_order : null
            }
            onSortChange={onSortChange}
            enableSearchMode={true}
          />
        </Box>
      ) as unknown as string,
    Cell: ({row }: { cell: any; row: any }) => {
      const name = row.original?.name;
      const formattedName = capitalizeFirstLetter(name);
      const clientDomain = row.original.domain;
      const orgId = row.original?.orgId;
      const subOrgId = row.original?.subOrgId;
      const [hover, setHover] = useState(false);
      const handleClientClick = () => {
        sessionStorage.setItem("selectedClient", clientDomain);
        row.original?.onClientClick(clientDomain, name, true, orgId, subOrgId, row.original?.accountRelationshipType, row.original?.salesforceAccountUrl, row.original?.salesforceAccountId);
      };
      const { featureMap } = useGlobalContext();
      const isClientAsk7GEnabled = featureMap?.client_ask_7g === true;
      return <Box className="flex flex-row gap-1 justify-center"
      sx={{
        justifyContent: "flex-start",
        alignItems: "center",
        alignContent: "flex-start",
        padding: "4px 8px",
        minWidth: 0,
      }}
    >
      <Box
        sx={{
          display: "inline-flex",
          alignItems: "center",
          flexGrow: 1,
          flexShrink: 1,
          minWidth: 0,
          overflow: "hidden",
        }}
      >
        <EllipsedTooltip tooltipContent={displayValue(formattedName)} maxWidth="100%">
          <span
          style={{
              textDecoration: "underline",
              textDecorationColor: "rgba(25, 118, 210, 0.4)",
              color: "#1976d2",
              cursor: "pointer",
            }}
            onClick={handleClientClick}
          >
        {displayValue(formattedName)}
          </span>
        </EllipsedTooltip>
        { isClientAsk7GEnabled && (
          <Box sx={{ flexShrink: 0, marginLeft: "5px", display: "flex", alignItems: "center" }}>
            <Tooltip title="Ask 7G" placement="top" arrow>
              <img
              onClick={() => row.original.onAskClick(row.original.domain, orgId, subOrgId)}
              src={hover? SelectedAsk7GIcon : Ask7GIcon}
              onMouseEnter={() => setHover(true)}
              onMouseLeave={() => setHover(false)}
              style={{
                width: "15px",
                height: "15px",
                cursor: "pointer",
              }}
              />
            </Tooltip>
          </Box>
        )}
      </Box>
    </Box>
    },
    enableColumnFilter: false,
    enableSorting: true,
    grow: true,
    minSize: 150,
    size: 150,
  },
  {
    accessorKey: "mrr",
    header: "MRR",
    Cell: ({ cell }: { cell: any }) => {
      return <Box>{displayValue(formatCurrency(cell.getValue() || 0))}</Box>;
    },
    enableColumnFilter: false,
    enableSorting: true,
    grow: true,
    minSize: 110,
    size: 110,
  },
  {
    accessorKey: "num_contacts",
    header: "No. of Contacts",
    Cell: ({ row }: { cell: any; row: any }) => {
      return (
        <span> {row.original?.num_contacts ?? "-"}</span>
      )
    },
    enableColumnFilter: false,
    enableSorting: false,
    grow: true,
    minSize: 120,
    //maxSize: 200,
    size: 120,
  },
  {
    accessorKey: "noOfInteractions",
    header: "No. of Interactions",
    Cell: ({ row }: { cell: any; row: any }) => {
      return (
        <span> {row.original.num_meetings}</span>
      )
    },
    enableColumnFilter: false,
    enableSorting: true,
    grow: true,
    minSize: 120,
    //maxSize: 200,
    size: 120,
  },
  {
    accessorKey: "lastInteractionDate",
    header: "Last Interaction Date",
    Cell: ({ row }: { row: any }) => {
      const summary = row.original?.last_interaction_summary;
      const lastInteractionDate = row.original?.last_interaction_Date
      return <Box>
        <Tooltip title={summary} placement="top">
            <span>
            {`${displayValue(validateDate(lastInteractionDate, "MMM DD, YYYY"))}`}
            </span>
        </Tooltip>
      </Box>;
    },
    enableColumnFilter: false,
    enableSorting: true,
    grow: true,
    minSize: 240,
    maxSize: 200,
    size: 240,
  },
  {
    accessorKey: "lastThreeRatedInteractions",
    header: "Last 3 Rating",
    Cell: ({ cell, row }: { cell: any; row: any }) => {
      const sentiments = cell.getValue() || [];
      
      const hasValidSentiment = sentiments.some(
        (s: any) => s.overall_sentiment
      );
    
      if (!hasValidSentiment) {
        return <Box>---</Box>; // Show "---" if no valid sentiment
      }

      return (
        <Box display="flex" flexDirection="row">
        {sentiments.length > 0
          ? (sentiments
              .filter((sentiment: any) => {
                // Ensure circle is only displayed if either overall_sentiment or classification_score exists
                return sentiment.overall_sentiment || sentiment.classification_score;
              })
              .sort((a: any, b: any) => new Date(a.start_time).getTime() - new Date(b.start_time).getTime()) // Sort by start_time in ascending order
              .map((sentiment: {
                start_time: any; interaction_id: string; summary: string; overall_sentiment: string, classification_score: string
              }, index: number) => {
                let color = ''; // Default color for neutral
                const sentimentValue = sentiment.overall_sentiment || sentiment.classification_score;

                if (sentimentValue && sentimentValue.toLowerCase() === 'positive') {
                  color = '#04BD00';
                } else if (sentimentValue && sentimentValue.toLowerCase() === 'negative') {
                  color = '#F4442F';
                } else if (sentimentValue && sentimentValue.toLowerCase() === 'neutral') {
                  color = '#FFCD2A';
                }

              return (
                <Tooltip
                  key={index}
                  title={
                    <>
                      <div>{sentiment.summary}</div>
                      <div>{validateDate(sentiment.start_time, "DD MMM YYYY")}</div> {/* Add start_time */}

                    </>
                  }
                  placement="top"
                  arrow
                >
                  <Box
                    display="flex"
                    alignItems="center"
                    marginRight={0.5}
                    sx={{ cursor: 'pointer' }}
                  >
                    <Link to={`/meeting/${sentiment.interaction_id}?${(() => {
                        const params = new URLSearchParams();
                        params.set("ci", "1");
                        params.set("ti", "1");
                        return params.toString();
                      })()}`}
                    state={{
                      is_team_meeting_id: true,
                      parent_page_identifier: row.original?.parentPageIdentifier,
                      slideOverParent: row.original?.slideOverParent,
                    }}
                    style={{ textDecoration: 'none', display: 'flex', alignItems: 'center' }}>
                      <Box
                        width={14}
                        height={14}
                        borderRadius="3px"
                        bgcolor={color}
                        marginRight={0.5}
                      />
                    </Link>
                  </Box>
                </Tooltip>
              );
            })
          ): null }
        </Box>
      );
    },
    enableColumnFilter: false,
    enableSorting: false,
    grow: true,
    minSize: 225,
    maxSize: 200,
    size: 225,
  },
];
};
export {getDefaultAccountColumns, initialSorting};